import React, { Fragment } from "react";
import PaymentGatewayBanner from "assets/images/YOOZ-PAYMENT-Gateway-banner.png";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import PartnersContent from "./content";
import PartnersHeader from "./header";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function Partners() {
    useDocumentTitle(
    "Accept Payments Online on Checkout | YOOZ",
    "Easily and securely accept Debit or Credit card payments on your website. Real-time payment updates applied to your accounting system."
  );
  return (
    <Fragment>
      <PageBanner img={PaymentGatewayBanner} />
      <ContentWrapper>
        <PartnersHeader />
        <PartnersContent />
      </ContentWrapper>
    </Fragment>
  );
}
